import { getShortDomain } from './getShortDomain.js';

const getDomainAttribute = ({ isCrossSubdomain = false } = {}) => {
  const shortDomain = getShortDomain({ isCrossSubdomain });
  return shortDomain === "localhost" ? "" : ` domain=${shortDomain};`;
};

export { getDomainAttribute };
